package com.dotdrives.web.pages.donor

import com.dotdrives.controller.DonorController
import com.dotdrives.controller.DonorUiState
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.strong
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

internal external interface ReceiptListProps : Props {
    var state: DonorUiState
    var controller: DonorController
}

internal val ReceiptList =
    FC<ReceiptListProps> { props ->
        val statements = props.state.snapshot?.statements.orEmpty()
        if (statements.isEmpty())
            p { +"No saved statements yet. Contact your organization to request one." }
        statements.forEach { statement ->
            div {
                className = ClassName("donor-receipt")
                strong { +"${statement.year} statement" }
                p { +"${donorMoney(statement.totalAmount)} · ${statement.giftCount} gifts" }
                p {
                    +(statement.snapshotSavedAt?.let { "Snapshot saved ${donorDate(it)}" }
                        ?: "Snapshot save date unknown")
                }
                button {
                    type = ButtonType.buttonType
                    disabled = props.state.documentBusy
                    onClick = { props.controller.document(statement.id) }
                    +"Download PDF"
                }
            }
        }
        p {
            className = ClassName("donor-secondary")
            +"Saved statements retain their issued totals; later gifts appear in your current giving totals."
        }
    }
